import React from 'react';

export default ({ x, y, text = [], textAnchor = "middle", style = { fill: '#8d8f90' }, showDot = false }) => {
  return (
    <g>
      {showDot && <circle cx={x} cy={y} r={2} fill="red" />}
      <text textAnchor={textAnchor} x={x} y={y} height="auto" style={{ fill: '#8d8f90', ...style }}>
        {text.map((t, i) => <tspan key={`text-${i}`} x={x} dy="1.1em">{t}</tspan>)}
      </text>
    </g>
  );
}


// WEBPACK FOOTER //
// ./src/components/svg/MultiLineText.js